/* ============================================================
   APLOMO TEQUILA — Theme JavaScript
   Handles: announcement bar, search modal, mini cart drawer,
   variant switching, live price update, quantity stepper,
   sticky buy box, AJAX add-to-cart, scroll animations,
   parallax, nav, tasting notes, testimonial carousel,
   mobile menu
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {

  /* ── INITIAL CART COUNT ──────────────────────────────────── */
  function refreshCartCount() {
    return fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var count = cart.item_count;
        document.querySelectorAll('#nav-cart-count, .mobile-cart-count-badge').forEach(function(el) {
          el.textContent = count;
          el.style.display = count > 0 ? 'flex' : 'none';
        });
        return cart;
      })
      .catch(function() { return null; });
  }
  refreshCartCount();

  /* ── HASH SCROLL ON PAGE LOAD ────────────────────────────── */
  if (window.location.hash) {
    const hashTarget = document.getElementById(window.location.hash.slice(1));
    if (hashTarget) {
      setTimeout(function () {
        hashTarget.scrollIntoView({ behavior: 'smooth' });
      }, 300);
    }
  }

  /* ── NAV SCROLL BEHAVIOR ─────────────────────────────────── */
  const nav = document.getElementById('aplomo-nav');
  const announcement = document.getElementById('aplomo-announcement');
  if (nav) {
    const onScroll = () => {
      const scrolled = window.scrollY > 40;
      nav.classList.toggle('scrolled', scrolled);
      if (announcement) {
        announcement.classList.toggle('announcement--hidden', scrolled);
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ── HERO PARALLAX ───────────────────────────────────────── */
  const heroBg = document.querySelector('.hero-bg');
  if (heroBg) {
    window.addEventListener('scroll', function () {
      const scrolled = window.scrollY;
      const heroHeight = document.getElementById('aplomo-hero')?.offsetHeight || window.innerHeight;
      if (scrolled < heroHeight) {
        const pct = scrolled / heroHeight;
        heroBg.style.transform = 'scale(1.1) translateY(' + (pct * 15) + '%)';
      }
    }, { passive: true });
  }

  /* ── HERO ENTRANCE ANIMATIONS ────────────────────────────── */
  setTimeout(function () {
    document.querySelectorAll('.hero-eyebrow, .hero-h1, .hero-sub, .hero-ctas, .hero-scroll')
      .forEach(function (el) { el.classList.add('visible'); });
  }, 100);

  /* ── SCROLL REVEAL (IntersectionObserver) ────────────────── */
  const revealObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        revealObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '-60px 0px' });

  document.querySelectorAll('.reveal, .craft-step').forEach(function (el) {
    revealObserver.observe(el);
  });

  /* ── MOBILE MENU ─────────────────────────────────────────── */
  const hamburger = document.getElementById('nav-hamburger');
  const mobileMenu = document.getElementById('mobile-menu');
  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', function () {
      hamburger.classList.toggle('open');
      mobileMenu.classList.toggle('open');
      document.body.style.overflow = mobileMenu.classList.contains('open') ? 'hidden' : '';
    });
    mobileMenu.querySelectorAll('a, button').forEach(function (el) {
      el.addEventListener('click', function () {
        hamburger.classList.remove('open');
        mobileMenu.classList.remove('open');
        document.body.style.overflow = '';
      });
    });
  }

  /* ── SMOOTH SCROLL FOR NAV LINKS ─────────────────────────── */
  document.querySelectorAll('[data-scroll-to]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      const sectionId = el.getAttribute('data-scroll-to');
      const target = document.getElementById(sectionId);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth' });
        const mm = document.getElementById('mobile-menu');
        if (mm) mm.classList.remove('open');
      } else {
        e.preventDefault();
        window.location.href = '/#' + sectionId;
      }
    });
  });

  /* ── SEARCH MODAL ────────────────────────────────────────── */
  const searchModal = document.getElementById('aplomo-search-modal');
  const searchInput = document.getElementById('aplomo-search-input');
  const searchClose = document.getElementById('search-modal-close');
  const searchBackdrop = document.getElementById('search-modal-backdrop');

  function openSearch() {
    if (!searchModal) return;
    searchModal.hidden = false;
    document.body.style.overflow = 'hidden';
    setTimeout(function() {
      if (searchInput) searchInput.focus();
    }, 50);
    document.querySelectorAll('#nav-search-btn, #nav-search-btn-mobile').forEach(function(btn) {
      btn.setAttribute('aria-expanded', 'true');
    });
  }

  function closeSearch() {
    if (!searchModal) return;
    searchModal.hidden = true;
    document.body.style.overflow = '';
    document.querySelectorAll('#nav-search-btn, #nav-search-btn-mobile').forEach(function(btn) {
      btn.setAttribute('aria-expanded', 'false');
    });
  }

  document.querySelectorAll('#nav-search-btn, #nav-search-btn-mobile').forEach(function(btn) {
    btn.addEventListener('click', openSearch);
  });
  if (searchClose) searchClose.addEventListener('click', closeSearch);
  if (searchBackdrop) searchBackdrop.addEventListener('click', closeSearch);
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      closeSearch();
      closeCartDrawer();
    }
  });

  /* ── MINI CART DRAWER ────────────────────────────────────── */
  const cartDrawer = document.getElementById('aplomo-cart-drawer');
  const cartDrawerBody = document.getElementById('cart-drawer-body');
  const cartDrawerFooter = document.getElementById('cart-drawer-footer');
  const cartDrawerTotal = document.getElementById('cart-drawer-total');
  const cartDrawerClose = document.getElementById('cart-drawer-close');
  const cartDrawerBackdrop = document.getElementById('cart-drawer-backdrop');

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function renderCartDrawer(cart) {
    if (!cartDrawerBody) return;
    if (cart.item_count === 0) {
      cartDrawerBody.innerHTML = '<div class="cart-drawer-empty"><p>Your cart is empty.</p><a href="/collections/all" class="btn-gold" style="margin-top:1.5rem;font-size:0.6rem;padding:0.875rem 2rem;">Shop Now</a></div>';
      if (cartDrawerFooter) cartDrawerFooter.style.display = 'none';
      return;
    }

    var html = '<ul class="cart-drawer-items">';
    cart.items.forEach(function(item) {
      html += '<li class="cart-drawer-item" data-key="' + item.key + '">';
      html += '<a href="' + item.url + '" class="cart-drawer-item-image-link">';
      html += '<img src="' + item.image + '" alt="' + item.title + '" width="72" height="72" loading="lazy">';
      html += '</a>';
      html += '<div class="cart-drawer-item-info">';
      html += '<a href="' + item.url + '" class="cart-drawer-item-title">' + item.product_title + '</a>';
      if (item.variant_title && item.variant_title !== 'Default Title') {
        html += '<p class="cart-drawer-item-variant">' + item.variant_title + '</p>';
      }
      html += '<p class="cart-drawer-item-price">' + formatMoney(item.final_line_price) + '</p>';
      html += '<div class="cart-drawer-item-qty">';
      html += '<button class="cart-drawer-qty-btn" data-action="decrease" data-key="' + item.key + '" data-qty="' + (item.quantity - 1) + '" aria-label="Decrease quantity">−</button>';
      html += '<span class="cart-drawer-qty-val">' + item.quantity + '</span>';
      html += '<button class="cart-drawer-qty-btn" data-action="increase" data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '" aria-label="Increase quantity">+</button>';
      html += '<button class="cart-drawer-remove" data-action="remove" data-key="' + item.key + '" aria-label="Remove item">Remove</button>';
      html += '</div>';
      html += '</div>';
      html += '</li>';
    });
    html += '</ul>';
    cartDrawerBody.innerHTML = html;

    if (cartDrawerTotal) cartDrawerTotal.textContent = formatMoney(cart.total_price);
    if (cartDrawerFooter) cartDrawerFooter.style.display = '';

    // Bind qty/remove buttons
    cartDrawerBody.querySelectorAll('[data-action]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var key = btn.getAttribute('data-key');
        var action = btn.getAttribute('data-action');
        var qty = action === 'remove' ? 0 : parseInt(btn.getAttribute('data-qty'), 10);
        updateCartItem(key, qty);
      });
    });
  }

  function updateCartItem(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      renderCartDrawer(cart);
      refreshCartCount();
    });
  }

  function openCartDrawer() {
    if (!cartDrawer) return;
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        renderCartDrawer(cart);
        cartDrawer.hidden = false;
        document.body.style.overflow = 'hidden';
        document.querySelectorAll('#nav-cart-btn, #nav-cart-btn-mobile').forEach(function(btn) {
          btn.setAttribute('aria-expanded', 'true');
        });
      });
  }

  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.hidden = true;
    document.body.style.overflow = '';
    document.querySelectorAll('#nav-cart-btn, #nav-cart-btn-mobile').forEach(function(btn) {
      btn.setAttribute('aria-expanded', 'false');
    });
  }

  // Cart nav buttons are now <a href="/cart"> links — no click override needed.
  // openCartDrawer is kept for programmatic use (e.g. after add-to-cart).
  if (cartDrawerClose) cartDrawerClose.addEventListener('click', closeCartDrawer);
  // Close when clicking outside the panel (on the dimmed overlay area)
  if (cartDrawer) {
    cartDrawer.addEventListener('click', function(e) {
      if (!e.target.closest('.cart-drawer-panel')) closeCartDrawer();
    });
  }

  /* ── AJAX ADD TO CART ────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;
    e.preventDefault();
    const variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    btn.disabled = true;
    const originalText = btn.innerHTML;
    btn.innerHTML = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function (res) {
      if (!res.ok) throw new Error('Cart add failed');
      return res.json();
    })
    .then(function () {
      btn.innerHTML = 'Added ✓';
      btn.classList.add('btn-cart--added');
      refreshCartCount();
      // Open cart drawer after add
      openCartDrawer();
      setTimeout(function () {
        btn.innerHTML = originalText;
        btn.classList.remove('btn-cart--added');
        btn.disabled = false;
      }, 2500);
    })
    .catch(function () {
      btn.innerHTML = 'Error — try again';
      setTimeout(function () {
        btn.innerHTML = originalText;
        btn.disabled = false;
      }, 2000);
    });
  });

  /* ── PRODUCT PAGE: VARIANT SWITCHING ─────────────────────── */
  var variantsJson = document.getElementById('product-variants-json');
  if (variantsJson) {
    var variants = JSON.parse(variantsJson.textContent);
    var selectedOptions = [];

    // Initialize selectedOptions from checked radio inputs
    document.querySelectorAll('.product-option-input').forEach(function(input) {
      if (input.checked) {
        var idx = parseInt(input.getAttribute('data-option-index'), 10);
        selectedOptions[idx] = input.value;
      }
    });

    function findVariant() {
      return variants.find(function(v) {
        return v.options.every(function(opt, i) {
          return opt === selectedOptions[i];
        });
      });
    }

    function updateVariantUI(variant) {
      if (!variant) return;

      // Update hidden variant id
      var hiddenId = document.getElementById('product-variant-id');
      if (hiddenId) hiddenId.value = variant.id;

      // Update price
      var priceEl = document.getElementById('product-price');
      var compareEl = document.getElementById('product-compare-price');
      if (priceEl) {
        priceEl.textContent = formatMoney(variant.price);
      }
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }

      // Update availability
      var availEl = document.getElementById('product-availability');
      var addBtn = document.getElementById('product-add-to-cart');
      if (availEl) {
        if (variant.available) {
          availEl.textContent = 'In stock';
          availEl.className = 'product-availability product-availability--in';
        } else {
          availEl.textContent = 'Sold out';
          availEl.className = 'product-availability product-availability--out';
        }
      }
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
      }

      // Update URL without reload
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    // Bind option inputs
    document.querySelectorAll('.product-option-input').forEach(function(input) {
      input.addEventListener('change', function() {
        var idx = parseInt(input.getAttribute('data-option-index'), 10);
        selectedOptions[idx] = input.value;

        // Update selected label
        var labelEl = document.getElementById('option-selected-' + idx);
        if (labelEl) labelEl.textContent = input.value;

        // Update swatch/size active state
        var group = input.closest('.product-swatches, .product-sizes');
        if (group) {
          group.querySelectorAll('.product-swatch, .product-size-btn').forEach(function(el) {
            el.classList.remove('product-swatch--selected', 'product-size-btn--selected');
          });
          var parentLabel = input.closest('.product-swatch, .product-size-btn');
          if (parentLabel) {
            parentLabel.classList.add(
              parentLabel.classList.contains('product-swatch') ? 'product-swatch--selected' : 'product-size-btn--selected'
            );
          }
        }

        var variant = findVariant();
        if (variant) updateVariantUI(variant);
      });
    });

    // Initial update
    var initialVariant = findVariant();
    if (initialVariant) updateVariantUI(initialVariant);
  }

  /* ── PRODUCT PAGE: IMAGE GALLERY ─────────────────────────── */
  var mainImage = document.getElementById('product-main-image');
  document.querySelectorAll('.product-gallery-thumb').forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      var src = thumb.getAttribute('data-image-src');
      var alt = thumb.getAttribute('data-image-alt');
      if (mainImage && src) {
        mainImage.src = src;
        mainImage.alt = alt || '';
      }
      document.querySelectorAll('.product-gallery-thumb').forEach(function(t) {
        t.classList.remove('product-gallery-thumb--active');
      });
      thumb.classList.add('product-gallery-thumb--active');
    });
  });

  /* ── PRODUCT PAGE: QUANTITY STEPPER ──────────────────────── */
  var qtyInput = document.getElementById('product-quantity');
  var qtyMinus = document.getElementById('product-qty-minus');
  var qtyPlus = document.getElementById('product-qty-plus');
  if (qtyInput && qtyMinus && qtyPlus) {
    qtyMinus.addEventListener('click', function() {
      var val = parseInt(qtyInput.value, 10) || 1;
      if (val > 1) qtyInput.value = val - 1;
    });
    qtyPlus.addEventListener('click', function() {
      var val = parseInt(qtyInput.value, 10) || 1;
      qtyInput.value = val + 1;
    });
  }

  /* ── PRODUCT PAGE: STICKY BUY BOX (mobile) ───────────────── */
  var buyBox = document.getElementById('product-buy-box');
  var productInfo = document.getElementById('product-info');
  if (buyBox && productInfo) {
    var stickyObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        buyBox.classList.toggle('product-buy-box--sticky', !entry.isIntersecting);
      });
    }, { threshold: 0 });
    // Observe the add-to-cart button's original position
    stickyObserver.observe(buyBox);
  }

  /* ── PRODUCT PAGE: AJAX ADD TO CART (product form) ───────── */
  var productForm = document.querySelector('[data-product-form]');
  if (productForm) {
    productForm.addEventListener('submit', function(e) {
      e.preventDefault();
      var addBtn = document.getElementById('product-add-to-cart');
      var variantId = document.getElementById('product-variant-id');
      var qtyEl = document.getElementById('product-quantity');
      if (!variantId) return;

      var originalText = addBtn ? addBtn.textContent : 'Add to Cart';
      if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Adding…'; }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          id: variantId.value,
          quantity: qtyEl ? (parseInt(qtyEl.value, 10) || 1) : 1
        })
      })
      .then(function(res) {
        if (!res.ok) throw new Error('Cart add failed');
        return res.json();
      })
      .then(function() {
        if (addBtn) { addBtn.textContent = 'Added ✓'; }
        refreshCartCount();
        openCartDrawer();
        setTimeout(function() {
          if (addBtn) { addBtn.textContent = originalText; addBtn.disabled = false; }
        }, 2500);
      })
      .catch(function() {
        if (addBtn) { addBtn.textContent = 'Error — try again'; }
        setTimeout(function() {
          if (addBtn) { addBtn.textContent = originalText; addBtn.disabled = false; }
        }, 2000);
      });
    });
  }

  /* ── TASTING NOTES TOGGLES ───────────────────────────────── */
  document.querySelectorAll('.tasting-toggle').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const panel = btn.nextElementSibling;
      const isOpen = btn.classList.contains('open');
      document.querySelectorAll('.tasting-toggle.open').forEach(function (other) {
        if (other !== btn) {
          other.classList.remove('open');
          other.nextElementSibling.classList.remove('open');
        }
      });
      btn.classList.toggle('open', !isOpen);
      if (panel) panel.classList.toggle('open', !isOpen);
    });
  });

  /* ── TESTIMONIAL CAROUSEL ────────────────────────────────── */
  const testimonials = [
    {
      quote: "Aplomo is the first tequila I\u2019ve tasted that feels like it was made for a specific moment \u2014 not just a drink, but an experience.",
      author: "Marcus T.",
      title: "Spirits Curator, New York"
    },
    {
      quote: "The A\u00f1ejo is extraordinary. Complex without being overwhelming. It has the kind of finish that makes you sit in silence for a moment.",
      author: "Isabelle R.",
      title: "Sommelier, Los Angeles"
    },
    {
      quote: "The Reposado is a revelation \u2014 you taste the land, the fire, the patience. This is what tequila was always meant to be.",
      author: "Diego M.",
      title: "Chef & Restaurateur, Mexico City"
    },
    {
      quote: "Aplomo Blanco is my go-to for cocktails that demand a premium spirit. The agave character is unmatched at this price point.",
      author: "Sarah K.",
      title: "Mixologist, Chicago"
    }
  ];

  const quoteEl = document.getElementById('testimonial-quote');
  const authorEl = document.getElementById('testimonial-author');
  const titleEl = document.getElementById('testimonial-title');
  const dotsEl = document.getElementById('testimonial-dots');

  if (quoteEl && authorEl && titleEl && dotsEl) {
    let current = 0;
    function setTestimonial(idx) {
      quoteEl.style.opacity = '0';
      setTimeout(function () {
        quoteEl.textContent = '\u201c' + testimonials[idx].quote + '\u201d';
        authorEl.textContent = testimonials[idx].author;
        titleEl.textContent = testimonials[idx].title;
        quoteEl.style.opacity = '1';
      }, 300);
      dotsEl.querySelectorAll('.testimonial-dot').forEach(function (dot, i) {
        dot.classList.toggle('active', i === idx);
      });
      current = idx;
    }
    testimonials.forEach(function (_, i) {
      const dot = document.createElement('button');
      dot.className = 'testimonial-dot' + (i === 0 ? ' active' : '');
      dot.setAttribute('aria-label', 'Testimonial ' + (i + 1));
      dot.addEventListener('click', function () { setTestimonial(i); });
      dotsEl.appendChild(dot);
    });
    setInterval(function () {
      setTestimonial((current + 1) % testimonials.length);
    }, 5000);
  }

  /* ── FOOTER "COMING SOON" LINKS ──────────────────────────── */
  document.querySelectorAll('[data-coming-soon]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      showToast((btn.getAttribute('data-coming-soon') || 'This page') + ' is coming soon.');
    });
  });

  function showToast(msg) {
    let toast = document.getElementById('aplomo-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'aplomo-toast';
      toast.style.cssText = [
        'position:fixed', 'bottom:2rem', 'left:50%', 'transform:translateX(-50%)',
        'background:#1a1914', 'border:1px solid rgba(201,168,76,0.3)',
        'color:#ece8de', 'font-family:Montserrat,sans-serif',
        'font-size:0.65rem', 'letter-spacing:0.15em', 'text-transform:uppercase',
        'padding:0.875rem 2rem', 'z-index:9999',
        'transition:opacity 0.3s ease', 'opacity:0'
      ].join(';');
      document.body.appendChild(toast);
    }
    toast.textContent = msg;
    toast.style.opacity = '1';
    clearTimeout(toast._timer);
    toast._timer = setTimeout(function () { toast.style.opacity = '0'; }, 3000);
  }

});
